import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  ApiKeyModel,
  CreateApiKeyRequest,
  UpdateApiKeyRequest
} from '@core/models/api-key/api-key.model';
import {
  ChangePasswordRequest,
  PasskeyModel
} from '@core/models/profile/profile-security.model';
import { UserModel } from '@core/models/user.model';

export const ProfileActions = createActionGroup({
  source: 'Profile',
  events: {
    // API Keys list
    'Load Keys': props<{ take?: number; cursor?: number }>(),
    'Load Keys Success': props<{
      keys: ApiKeyModel[];
      cursorNextPage: number | null;
      cursorPrevPage: number | null;
    }>(),
    'Load Keys Failure': props<{ error: string }>(),

    // Single API Key
    'Load Key': props<{ keyId: number }>(),
    'Load Key Success': props<{ key: ApiKeyModel }>(),
    'Load Key Failure': props<{ error: string }>(),

    // Create API Key
    'Create Key': props<{ data: CreateApiKeyRequest }>(),
    'Create Key Success': props<{ key: ApiKeyModel; apiKeyValue: string }>(),
    'Create Key Failure': props<{ error: string }>(),

    // Update API Key
    'Update Key': props<{ keyId: number; data: UpdateApiKeyRequest }>(),
    'Update Key Success': props<{ key: ApiKeyModel }>(),
    'Update Key Failure': props<{ error: string }>(),

    // Delete API Key
    'Delete Key': props<{ keyId: number }>(),
    'Delete Key Success': props<{ keyId: number }>(),
    'Delete Key Failure': props<{ error: string }>(),

    // Clear created key value
    'Clear Created Key Value': emptyProps(),

    // Reset form
    'Reset Form': emptyProps(),

    // Password
    'Change Password': props<{ data: ChangePasswordRequest }>(),
    'Change Password Success': emptyProps(),
    'Change Password Failure': props<{ error: string }>(),

    // TOTP (Keycloak-backed)
    'Load Totp Status': emptyProps(),
    'Load Totp Status Success': props<{ enabled: boolean }>(),
    'Load Totp Status Failure': props<{ error: string }>(),

    'Disable Totp': emptyProps(),
    'Disable Totp Success': emptyProps(),
    'Disable Totp Failure': props<{ error: string }>(),

    // Passkeys
    'Load Passkeys': emptyProps(),
    'Load Passkeys Success': props<{ passkeys: PasskeyModel[] }>(),
    'Load Passkeys Failure': props<{ error: string }>(),

    'Delete Passkey': props<{ id: string }>(),
    'Delete Passkey Success': props<{ id: string }>(),
    'Delete Passkey Failure': props<{ error: string }>(),

    // Profile name
    'Update Profile Name': props<{ data: { firstName?: string; lastName?: string } }>(),
    'Update Profile Name Success': props<{ user: UserModel }>(),
    'Update Profile Name Failure': props<{ error: string }>(),
    'Reset Profile Name Form': emptyProps()
  }
});
